<template>
    <div class="row">
        <div class="col-lg-12 mx-auto">
            <div class="main_title">
                <h1 class="mb-0 font-active" v-if="$country.is_india">The Heartbeat of Our Success</h1>
                <h1 class="mb-0 font-active" v-else>This is why we do, what we do!</h1>

                <h2 class="mb-0" v-if="$country.is_india">
                    Behind Friendly Diamonds' success? Your smiles, kind words and unwavering trust. 
                    <br><br>
                    With a global clientele spanning across continents, our success resonates with satisfied customers worldwide. Experience the seamless distribution of diamonds beyond borders. Share your story with us and receive a complimentary diamond Solitaire Pendant* today!
                </h2>
                <h2 class="mb-0" v-else>
                    Do you know the inspiration behind the success of Friendly Diamonds? It's the customer’s delighted smiles, their nice words of gratitude, and most importantly their trust. Get a complimentary diamond Solitaire Pendant on telling us your story and your experience with us*
                </h2>

                <div class="mx-auto share_cta text-center">
                    <CommonBasePrimary @click="showModal" type="submit">Share your moment</CommonBasePrimary>
                    <NuxtLink class="mt-1" :to="localePath('/free-product')"> * <span>Terms and Conditions Apply</span></NuxtLink>
                </div>
            </div>
            <!-- Button trigger modal -->
           
            <!-- Modal -->
            <div v-if="flagShowModal">
                <Teleport  to="#teleports">
                    <div class="modal fade" data-bs-backdrop="true" id="sharemoment" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref="myModalRef">
                        <div class="modal-dialog">
                            <div class="modal-content">                     
                                <div class="modal-body model_block">
                                    <form enctype="multipart/form-data" ref="moment_form" @submit.prevent="submit">
                                        <div class="title_block">
                                            <h3 class="mb-0 font-active">We'd love to know your story!</h3>
                                            <span data-bs-dismiss="modal" aria-label="Close"><SvgHeaderSvg type="close" class="largesvg"/></span>
                                        </div>
                                        <div class="row mt-4 moment_form" role="group">
                                            <div class="col-md-12 pb-3 column">
                                                <label class="mb-2">Your Email Address *</label>
                                                <input  name="email" :class="{ 'is-invalid': errorMessages.email }" type="email" v-model="formData.email" />
                                                <span v-if="errorMessages.email" class="error-msg">{{ errorMessages.email.join(' ') }}</span>
                                            </div>
                                            <div class="col-md-12 pb-3 column">
                                                <label class="mb-2">Order Reference Number *</label>
                                                <input name="order_ref" :class="{ 'is-invalid':errorMessages.order_ref }"  type="text" v-model="formData.order_ref" />
                                                <span v-if="errorMessages.order_ref" class="error-msg">{{ errorMessages.order_ref.join(' ') }}</span>
                                            </div>
                                            <div class="col-md-12 pb-3 column">
                                                <label class="mb-2">Your Name *</label>
                                                <input name="name" :class="{ 'is-invalid':errorMessages.name }" type="text" v-model="formData.name"/>
                                                <span v-if="errorMessages.name" class="error-msg">{{ errorMessages.name.join(' ') }}</span>
                                            </div>
                                            <div class="col-md-12 pb-3 column">
                                                <label class="mb-2">Partner's Name *</label>
                                                <input name="partners_name" :class="{ 'is-invalid': errorMessages.partners_name }" type="text" v-model="formData.partners_name" />
                                                <span v-if="errorMessages.partners_name" class="error-msg">{{ errorMessages.partners_name.join(' ') }}</span>
                                            </div>
                                            <div class="col-md-12 pb-3 column">
                                                <label class="mb-2">Address (city, state, country) *</label>
                                                <input name="address" :class="{ 'is-invalid': errorMessages.address }" type="text" v-model="formData.address"/>
                                                <span v-if="errorMessages.address" class="error-msg">{{ errorMessages.address.join(' ') }}</span>
                                            </div>
                                            <div class="col-md-12 pb-3">
                                                <p class="mb-0">Get Tagged on Instagram</p>
                                            </div>
                                            <div class="col-md-12 pb-3 column">
                                                <label class="mb-2">Your Instagram Handle</label>
                                                <input name="instagram" :class="{ 'is-invalid': errorMessages.instagram }"  type="text" v-model="formData.instagram" />
                                                <span v-if="errorMessages.instagram" class="error-msg">{{ errorMessages.instagram.join(' ') }}</span>
                                            </div>
                                            <div class="col-md-12 pb-3 column">
                                                <label class="mb-2">Partner's Instagram Handle</label>
                                                <input name="partners_instagram" :class="{ 'is-invalid': errorMessages.partners_instagram }" type="text" v-model="formData.partners_instagram" />
                                                <span v-if="errorMessages.partners_instagram" class="error-msg">{{ errorMessages.partners_instagram.join(' ') }}</span>
                                            </div>
                                            
                                            <div class="col-md-12 pb-3">
                                                <p class="mb-0">Take us through your relationship journey & the magical moment when you or your better half popped the question. Tell us how you feel about your Friendly Diamonds experience.</p>
                                            </div>
                                            <div class="col-md-12 pb-3 column">
                                                <div class="textarea_box">
                                                    <label class="mb-2" for="">Your Story *</label>
                                                    <textarea class="form-control form-control-lg" name="story" required rows="8" maxlength="2000" :class="{ 'is-invalid': errorMessages.story }" v-model="formData.story"  />
                                                    <span v-if="errorMessages.story" class="error-msg">{{ errorMessages.story.join(' ') }}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-12 pb-4 column">
                                                <div class="textarea_box">
                                                    <label class="mb-2" for="">Upload Images *</label>
                                                    <input type="file" multiple @change="handleFileUpload" class="file-input" />
                                                    <span v-if="errorMessages.pictures" class="error-msg mt-2">{{ errorMessages.pictures.join(' ') }}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-12 pb-3 filter_box">
                                                <p class="mb-2">Rate your Friendly Diamonds experience</p>
                                                <div class="form-group">
                                                <div class="custom-control custom-radio">
                                                    <input class="custom-control-input" type="radio" v-model="formData.experience" name="experience" value="1">
                                                    <label class="custom-control-label">&nbsp;1</label>
                                                </div>
                                                <div class="custom-control custom-radio">
                                                    <input class="custom-control-input" type="radio" v-model="formData.experience" name="experience" value="2">
                                                    <label class="custom-control-label">&nbsp;2</label>
                                                </div>
                                                <div class="custom-control custom-radio">
                                                    <input class="custom-control-input" type="radio" v-model="formData.experience" name="experience" value="3">
                                                    <label class="custom-control-label">&nbsp;3</label>
                                                </div>
                                                <div class="custom-control custom-radio">
                                                    <input class="custom-control-input" type="radio" v-model="formData.experience" name="experience" value="4">
                                                    <label class="custom-control-label">&nbsp;4</label>
                                                </div>
                                                <div class="custom-control custom-radio">
                                                    <input class="custom-control-input" type="radio" v-model="formData.experience" name="experience" value="5">
                                                    <label class="custom-control-label">&nbsp;5</label>
                                                </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12 pb-3 filter_box column">
                                                <div class="filter_row mb-2">
                                                    <div class="checkbox_custom ms-0 t_c_box">
                                                        <div class="tc_input">
                                                            <span :class="formData.terms_condition ? 'checked' : 'unchecked'" @click="formData.terms_condition = !formData.terms_condition"></span>
                                                            <input class="form-check-input" type="checkbox" id="terms_condition" v-model="formData.terms_condition">
                                                        
                                                            <label class="form-check-label mb-0" for="termsCheckbox" @click="expand_terms = !expand_terms">&nbsp;I accept all the <u>Terms & Conditions</u></label>                                                     
                                                        </div>
                                                        <div class="tc_arrow ms-auto" @click="expand_terms = !expand_terms">
                                                            <SvgHeaderSvg v-if="!expand_terms" :type="'down'" />
                                                            <SvgHeaderSvg v-else :type="'up'" />
                                                        </div>
                                                    </div>
                                                    <span class="error-msg" v-if="terms_error">Please accept the Terms & Conditions</span>
                                                    <div class="expand_block mt-2" v-if="expand_terms">
                                                        <ul>
                                                            <li>Every purchase made on the Friendly Diamonds’ website qualifies for this special offer.</li>
                                                            <li>This offer cannot be combined with any other ongoing promotions.</li>
                                                            <li>Your current purchase will not qualify for another free product if you have already received any other complimentary item on your previous orders.</li>
                                                            <li>One Solitaire Pendant is included per customer’s valuable feedback, regardless of the number of qualifying purchases during the offer period.</li>
                                                            <li>To qualify, the customer is required to submit the duly filled Share Your Moment form and their reviews on a minimum of 2 of our review platforms.</li>
                                                            <li>Ensure your submission comprises a minimum of 2 images or videos, with the purchased item from Friendly Diamonds prominently visible, and the purchaser or consumer actively engaged in at least one visual.</li>
                                                            <li>The total size of the uploaded images and videos cannot exceed 40MB.</li>
                                                            <li>The Solitaire Pendant is non-negotiable, non-refundable, and will not be replaced if lost, misplaced, or stolen.</li>
                                                            <li>Reporting and payment of all customs duties and taxes linked to its receipt are the exclusive responsibility of the purchaser.</li>
                                                            <li>Friendly Diamonds does not provide any warranty on the Solitaire Pendant, and reserves the right, at its sole discretion, to withhold the pendant in the event of any fraud or deception.</li>
                                                            <li>Offer valid while supplies last, and the offer terms are subject to change at any time without prior notice.</li>
                                                            <li>By participating in this offer, you agree to grant Friendly Diamonds the right to use any images or videos submitted for marketing purposes. Usage may include, but is not limited to, the website, social platforms, digital ads, newsletters, email marketing, blogs, and 3rd party blogs, as well as other suitable mediums.</li>
                                                            <li>Other restrictions may apply.</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                            <div v-if="!showSuccess" class="col-md-12 pb-3">
                                                <CommonBasePrimary v-if="showLoader">please wait...</CommonBasePrimary>
                                                <CommonBasePrimary v-else type="submit">submit</CommonBasePrimary>
                                            </div>
                                            <div v-if="showSuccess" class="col-md-12 pb-4">
                                                <div class="alert alert-primary mb-0" role="alert">Thank you for sharing your moments with us!</div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </Teleport>
            </div>

        </div>
    </div>
</template>

<script setup>
    const localePath = useLocalePath()
    const { $toast } = useNuxtApp()
    const { $country } = useNuxtApp()
    const formData = reactive({
            email: '',
            order_ref: '',
            name: '',
            partners_name: '',
            address: '',
            instagram: '',
            partners_instagram: '',
            story: '',
            pictures: [],
            experience: '5',
            terms_condition: false,
    });
      
    const errorMessages = ref({});
    const showSuccess = ref(false);
    const showLoader = ref(false);
    const terms_error = ref(false);
    const expand_terms = ref(false);
    const flagShowModal = ref(false);
    const fileSizeError = ref(false);
    const files = ref(null);
    const myModalRef = ref(null);

    const emptyData = () => {
        formData.email = '';
        formData.order_ref = '';
        formData.name = '';
        formData.partners_name = '';
        formData.instagram = '';
        formData.partners_instagram = '';
        formData.address = '';
        formData.story = '';
        formData.experience = '5';
        formData.terms_condition = false;
    };

    const showModal = () => {
        flagShowModal.value = true;
        nextTick(() => {
        const modalElement = myModalRef.value;
        if (modalElement) {
        const modalInstance = new bootstrap.Modal(modalElement);
        modalInstance.show();
        }
        });
    };

    const hideModal = () => {
        const modalElement = myModalRef.value;
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        flagShowModal.value = false;
    };

    const handleFileUpload = (event) => {
        fileSizeError.value = false;
        files.value = event.target.files;
        if (!event.target.files) {
            // Handle case where files are not defined (perhaps no files were selected)
            files.value = null; // Ensure files.value is explicitly set to null or handle accordingly
            return;
        }
        const file = event.target.files[0];
        const maxFileSizeBytes = 40 * 1024 * 1024; // 40 MB as an example
        if (file && file.size > maxFileSizeBytes) {
            fileSizeError.value = true;
        }
    };

    const submit = async () => {
        errorMessages.value = {};
        terms_error.value = false;
        if (formData.value && !formData.value.terms_condition) {
            terms_error.value = true;
            return;
        }
        if (fileSizeError.value) {
            errorMessages.value.pictures = ["The media file type must be a (jpg,jpeg,png,mp4,webp,webm,mov,heic) and size must not exceed 40MB."];
            return;
        }
        showLoader.value = true;
        const formBody = new FormData();
        // Check if files.value is defined and not null
        if (files.value && files.value.length > 0) {
            for (let i = 0; i < files.value.length; i++) {
                const file = files.value[i];
                formBody.append(`pictures[${i}]`, file);
            }
        }
        formBody.append('email', formData.email);
        formBody.append('order_ref', formData.order_ref);
        formBody.append('name', formData.name);
        formBody.append('partners_name', formData.partners_name);
        formBody.append('instagram', formData.instagram);
        formBody.append('partners_instagram', formData.partners_instagram);
        formBody.append('address', formData.address);
        formBody.append('story', formData.story);
        formBody.append('experience', formData.experience);
        formBody.append('terms_condition', formData.terms_condition);
        
        try {
            const response = await $fetch(useCountryPath('/testimonial/store') , {
                method: 'POST',
                body: formBody            
            })
            if (response.success) {
            showSuccess.value = true
            showLoader.value = false
             emptyData()
             setTimeout(() => {
              flagShowModal.value = false
              showSuccess.value = false
              hideModal()
             }, 2000)

            }
        } 
        catch (error) {
            showLoader.value = false;
            if(error.status === 422){
                errorMessages.value = error.data.errors;
            }
            if(error.status === 500){
                $toast('alert',"Something went wrong, Please try again")
            }
            // errorMessages.value = error.data.error;
        } 
        finally {
             showLoader.value = false; 
        }
    };
</script>


<style scoped>
.largesvg {
    transform: scale(1.3);
}
.textarea_box input[type="file"] {
    border: none; 
    outline: none; 
    box-shadow: none; 
}
a{
    color: #6a6161;
    font-size: 14px;
    display: inline-block;
    font-weight: 500;
}
a span{
    border-bottom: 1px solid #6a6161;
}
.t_c_box label {
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
}
.t_c_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
.modal-content{
    border-radius: 8px;
}
input, textarea {
    border-radius: 4px ;
}
.tc_input {
    display: flex;
    align-items: center;
}

.tc_input input{
    display: none;
}

.expand_block  ul {
    padding: 10px 0 0 20px;
}

.expand_block ul li {
    color: #606060;
    font-size: 14px;
}
 textarea.invalid {
    border-color: #fc7979 !important;
}
textarea{
    font-size: 16px;
    width: 100%;
    font-weight: 500;
}
textarea::placeholder{
    font-size: 14px;
    color:  #363030;
}
.main_title {
    margin-bottom: 4%;
}
.main_title h1 {
    font-size: 32px;
    text-align: center;
}
.main_title h2 {
    text-align: center;
    color: #6a6161;
    font-size: 16px;
    padding: 3% 0;
}
.main_title .share_cta{
    width: 28%;
}
.moment_form p {
    font-size: 16px;
    font-weight: 600;
} 

.title_block{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.title_block span {
    cursor: pointer;
}
.title_block h3 {
    font-size: 20px;
}
.custom-control.custom-radio {
    display: inline-block;
    margin-right: 15px;
}

.down_arrow {
    height: 8px;
    width: 8px;
    border-bottom: 1px solid #000;
    border-right: 1px solid #000;
    transform: rotate(-135deg);
    transition: 0.5s;
    margin: 10px;
}
.up_arrow {
    height: 8px;
    width: 8px;
    border-bottom: 1px solid #000;
    border-right: 1px solid #000;
    transform: rotate(45deg);
    transition: 0.5s;
    margin: 10px;
}
.according_title {
    /* font-size: 18px; */
    /* padding: 1.3% 0; */
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
@media(max-width: 767px){
    .main_title .share_cta{
        width: 100%;
    }
   
    .main_title h1 {
        font-size: 24px;
        text-align: center;
    }
    .main_title h2 {
        text-align: center;
        font-size: 16px;
        padding: 6% 0;
    }
}

</style>
